<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal
      :title="'Send Reminder'"
      subtitle="Type your message below"
      btnlefttext="Send"
      btncentertext="Cancel"
      btnrighttext=""
      :leftloading="send_loading"
      :rightloading="false"
      :centerloading="false"
      :footerhidden="false"
      footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px"
      body_padding="0px 30px"
      width="1090px"
      :hiderightbtn="false"
      @onLeftClick="submitRemainder()"
      @onCenterClick="closeRemainder()"
    >
      <div class="widget-modal-body-noscoll">
        <div class="form-widget">
          <div class="user-widget" v-if="type == 'student'">
            <widgetProfile
              :size="50"
              :title="user.first_name + ' ' + user.last_name"
              :subtitle="user.profile ? user.profile.address : ''"
              :file_name="user.profile_picture"
              :path="$fullUrl('images/profiles/')"
            ></widgetProfile>
          </div>
          <div class="send-options">
            <div class="option">
              <input
                type="radio"
                v-model="form.type"
                value="notification"
                name="type"
              />
              <span>Send as Notification</span>
            </div>
            <div class="option">
              <input
                type="radio"
                v-model="form.type"
                value="message"
                name="type"
              />
              <span>Send as Message</span>
            </div>
          </div>
          <div class="message-content">
            <HtmlEditor
              v-model="form.message"
              placeholder="Type here..."
              id="edit-descr"
            ></HtmlEditor>
          </div>
        </div>
        <div class="sample-widget">
          <div class="header">
            <h2>Samples</h2>
            <filter-select
              class="filter-widget"
              v-model="selected_filter"
              :content="view_filter"
            >
              <div class="filter-selected-label">
                <span v-if="selected_filter == 'notification'"
                  >Notification</span
                >
                <span v-if="selected_filter == 'email'">Email</span>
              </div>
            </filter-select>
          </div>
          <div class="body" v-if="selected_filter == 'notification'">
            <div
              class="item"
              v-for="(item, index) in notification_data"
              :key="index"
              @click="selectMessage(item)"
            >
              <p v-html="item.description"></p>
            </div>
          </div>
          <div class="body" v-if="selected_filter == 'email'">
            <div
              class="item"
              v-for="(item, index) in email_data"
              :key="index"
              @click="selectMessage(item)"
            >
              <p v-html="item.description"></p>
            </div>
          </div>
        </div>
      </div>
    </widgetModal>
  </div>
</template>

<script>
export default {
  name: "remainder-widget",
  props: {
    type: {
      type: String,
      default: "student",
    },
    phase: {
      type: String,
      default: "phase_1",
    },
    user: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  data() {
    return {
      send_loading: false,
      view_filter: [
        {
          value: "notification",
          name: "Notification",
        },
        {
          value: "email",
          name: "Email",
        },
      ],
      selected_filter: "notification",
      form: {
        user_id: null,
        company_id: null,
        type: "notification",
        phase: "phase_1",
        message: "",
        remind_type: "",
      },
      email_data: [],
      notification_data: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.getEmailData();
    vm.getNotificationData();
  },
  methods: {
    submitRemainder() {
      let vm = this;
      vm.form.remind_type = vm.type;
      vm.form.phase = vm.phase;
      if (vm.type == "checked") {
        vm.form.user_id = vm.user;
      }
      if (vm.type == "student") {
        vm.form.user_id = vm.user.id;
      }
      if (
        vm.type == "checked" ||
        vm.type == "student" ||
        vm.type == "all_student"
      ) {
        vm.send_loading = true;
        vm.$store
          .dispatch("INSTRUCTOR_SEND_SCHOOL_STUDENT_REMAINDER", vm.form)
          .then((responce) => {
            vm.send_loading = false;
            vm.closeRemainder();
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Reminder is now sent",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.send_loading = false;
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      }

      if (vm.type == "all_company") {
        vm.send_loading = true;
        vm.$store
          .dispatch("INSTRUCTOR_SEND_ALL_COMPANY_REMAINDER", vm.form)
          .then((responce) => {
            vm.send_loading = false;
            vm.closeRemainder();
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Reminder is now sent",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.send_loading = false;
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    selectMessage(item) {
      let vm = this;
      vm.form.message = item.description;
    },
    getEmailData() {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_GET_ALL")
        .then((responce) => {
          vm.email_data = responce.data;
        })
        .catch((error) => {});
    },
    getNotificationData() {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_NOTIFICATION_GET_ALL")
        .then((responce) => {
          vm.notification_data = responce.data;
        })
        .catch((error) => {});
    },
    closeRemainder() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.widget-modal-body-noscoll {
  display: flex !important;
  padding-top: 20px;
  height: 100%;
  .form-widget {
    margin-right: 20px;
    height: 100%;
    width: calc(100% - 300px);
    .user-widget {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .send-options {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;

      .option {
        margin-right: 20px;

        input[type="radio"] {
          position: relative;
          top: 3px;
        }
      }
    }
  }

  .sample-widget {
    background: #f3f3f3;
    border-radius: 10px;
    width: 300px;
    height: 100%;
    .header {
      display: flex;
      flex-direction: column;
      padding: 10px;
      height: 70px;
      h2 {
        font-size: 17px;
        margin: 0px;
      }

      .filter-widget {
        width: 120px;

        .filter-selected-label {
          color: #0884af;
        }
      }
    }
    .body {
      height: calc(100% - 70px);
      padding: 0px 10px;
      overflow-y: auto;
      .item {
        background: #fff;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;

        p {
          line-height: 17px;
          text-align: justify;
        }
      }
    }
  }
}
</style>